import { v4 as uuidv4 } from "uuid";

const COOKIE_KEY = "device_id";
const MAX_AGE = 63072000; // 2 years in seconds

/**
 * Get or create a persistent device ID (client-only version for React)
 */
export const getOrCreateDeviceId = (): string => {
  // 1. Try localStorage first
  let deviceId: string | null = null;

  try {
    deviceId = localStorage.getItem(COOKIE_KEY);
  } catch {
    console.warn("⚠️ localStorage not available, will use session cookie");
  }

  // 2. If exists, return it
  if (deviceId) return deviceId;

  // 3. Otherwise, generate a new UUID
  deviceId = uuidv4();

  // 4. Save to localStorage (if available)
  try {
    localStorage.setItem(COOKIE_KEY, deviceId);
  } catch {
    console.error("❌ Failed to save device ID to localStorage");
  }

  // 5. Also set a cookie for other contexts
  setClientCookie(deviceId);

  return deviceId;
};

/**
 * Set a client-readable cookie for device ID
 */
const setClientCookie = (value: string) => {
  const expires = new Date(Date.now() + MAX_AGE * 1000).toUTCString();
  document.cookie = `${COOKIE_KEY}=${value}; expires=${expires}; path=/; Secure; SameSite=None`;
};

/**
 * Optional helper: read device ID from cookies
 */
export const getDeviceIdFromCookies = (): string | null => {
  const cookies = document.cookie.split(";").reduce((acc, cookie) => {
    const [name, ...rest] = cookie.trim().split("=");
    acc[name] = rest.join("=");
    return acc;
  }, {} as Record<string, string>);

  return cookies[COOKIE_KEY] || null;
};
